// Shared geometry keeps the examples aligned without obscuring their token styles.
export const plot = { left: 48, right: 576, top: 72, bottom: 264, padding: 24 };
